<template lang="pug">
    div.dashboard-charts
        .line-chart
            AllocationLinearGraph(:name="linearName" :allocationMetrics="allocationMetrics" className="top100-linechart--attribution")
        .doughnut-chart
            AllocationDoughnut(:name="doughnutName" :allocationMetrics="allocationMetrics" className="top100-linechart--attribution")
</template>

<script>
import { mapState } from 'vuex'
import { getAllocationMetrics } from '@/store/dashboard/helpers'
import AllocationDoughnut from '@/components/dashboard/AllocationDoughnut'
import AllocationLinearGraph from '@/components/dashboard/AllocationLinearGraph'

export default {
    name: 'AllocationCharts',

    components: {
        AllocationDoughnut,
        AllocationLinearGraph
    },

    props: {
        doughnutName: { type: String, required: true },
        linearName: { type: String, required: true },
        allocationData: { type: [Object, Array], required: true },
        allocationTimeUnit: { type: String, required: true }
    },

    computed: {
        ...mapState('dashboard', {
            selectedTimeRange: state => state.selectedTimeRange
        }),

        allocationMetrics() {
            return getAllocationMetrics(this.allocationData, this.allocationTimeUnit, null, this.selectedTimeRange[0], this.selectedTimeRange[1])
        }
    }
}
</script>
